export const apiHost = '';

export const supportedCurrencies = ['EUR', 'USD', 'GBP', 'CAD'];

export const BYPASS_BOOKING_PREVIEW = true;
